export const formatCurrency = (
  number: number | string,
  minDigits = 2,
  maxDigits = 7
) => {
  if (!number) return null;
  const formatter = Intl.NumberFormat("en", {
    maximumFractionDigits: maxDigits,
    style: "currency",
    currency: "USD",
    minimumFractionDigits: minDigits
  });
  return formatter.format(Number(number));
};

export const formatPercentage = (number: number | string) => {
  if (!number) return null;
  return `${number}%`;
};

export const formatMarketCap = (number: string) => {
  const formatter = Intl.NumberFormat("en", {
    notation: "compact",
    maximumSignificantDigits: 4
  });

  if (!number) return null;

  return `$${formatter.format(Number(number))}`;
};

export const formatSupply = (number: number) => {
  const formatter = Intl.NumberFormat("en", {
    notation: "compact",
    maximumSignificantDigits: 4
  });

  return formatter.format(number);
};
